export const navigateAfterOrderEdit = (navigate, locationState, fallbackPath = "/main") => {
  navigate(locationState?.returnToOrdersList ? -1 : fallbackPath);
};
